// removed by extract-text-webpack-plugin
module.exports = {"drawer":"drawer___3xvEI","drawer--expanded":"drawer--expanded___1ZkwM","collapseButton":"collapseButton___3J9Vm","collapseButton--visible":"collapseButton--visible___3TXk9","collapseIcon":"collapseIcon___ocy_Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Drawer/Drawer.module.scss
// module id = 2143
// module chunks = 0